const PREFERENCE_SUBTYPE_BASE = "asset-view"

export function getPreferenceSubTypeForPanel(panelId) {
  return panelId ? `${PREFERENCE_SUBTYPE_BASE}.${panelId}` : PREFERENCE_SUBTYPE_BASE
}

export function getAssetViewPreferencePersistencePlan({
  panelId,
  duplicateFromPanelId,
  isSecondary,
  shouldUseLegacyPreferences,
}) {
  const storesPreferencesUnderLegacyKey = Boolean(
    shouldUseLegacyPreferences === true
    && panelId
    && !duplicateFromPanelId
    && !isSecondary,
  )
  const preferencePersistenceSubType = storesPreferencesUnderLegacyKey
    ? PREFERENCE_SUBTYPE_BASE
    : getPreferenceSubTypeForPanel(panelId)
  const mirrorSaveSubType = storesPreferencesUnderLegacyKey
    ? getPreferenceSubTypeForPanel(panelId)
    : undefined

  return {
    storesPreferencesUnderLegacyKey,
    preferencePersistenceSubType,
    mirrorSaveSubType,
  }
}
